import React from "react";
import { TrendingIcon } from "./TrendingIcon";
import styles from "./PercentageChangeBlock.module.scss";

interface PercentageChangeBlockProps {
  value: number;
  fontSize?: string | number;
  className?: string;
}

export const PercentageChangeBlock: React.FC<PercentageChangeBlockProps> = ({ value, fontSize, className }) => {
  const isUp = value > 0;
  // Always provide an object for style
  const style = fontSize ? { fontSize } : undefined;
  const iconSize = fontSize
    ? typeof fontSize === 'number'
      ? Math.round(Number(fontSize))
      : undefined
    : 16;
  return (
    <div
      className={`${isUp ? styles.priceUp : styles.priceDown} ${className || ''}`}
      style={style}
      aria-label={isUp ? `Up ${Math.abs(value).toFixed(2)} percent` : `Down ${Math.abs(value).toFixed(2)} percent`}
    >
      <TrendingIcon direction={isUp ? "up" : "down"} className={styles.trendingIcon} width={iconSize} height={iconSize} />
      {Math.abs(value).toFixed(2)}%
    </div>
  );
};
